module.exports = __webpack_public_path__ + "static/img/pclogo.4fde65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pclogo.png
// module id = P0Li
// module chunks = 1